import { PubSub } from './pubsub';
import { Topic } from './topic';
export class Intercom {
    constructor(actorId) {
        this.releaseVersion = '20.0.1';
        this.modelVersion = 12;
        this.actorId = actorId;
        this.pubSub = new PubSub(actorId, this.releaseVersion, this.modelVersion);
    }
    publish(topic, payload, destination) {
        this.pubSub.publish(topic, payload, this.modelVersion, destination);
    }
    subscribe(topic, onReceiveCallback) {
        this.pubSub.subscribe(topic, onReceiveCallback, this.modelVersion);
    }
    unsubscribe(topic) {
        this.pubSub.unsubscribe(topic);
    }
    requestToRepublish(topic) {
        this.pubSub.publish(Topic.REPUBLISH, topic, this.modelVersion);
    }
    getActorId() {
        return this.actorId;
    }
}
//# sourceMappingURL=intercom.js.map